function initTimer(interval, el, circleSlector, allTime) {
  if (!circleSlector) {
    return false;
  }

  const $circleEl = el.querySelector(`.${circleSlector}`);
  let degrees = 0;

  if (!$circleEl) {
    return false;
  }

  clearGradient($circleEl);

  return setInterval(() => {
    if (degrees > 360) {
      clearGradient($circleEl);
      clearInterval(interval);
    }

    createGradient($circleEl, degrees, '#7c9903');
    degrees += (360 / 100);
  }, allTime / 100);
}

function createGradient(elem, d, fill, track) {
  fill = fill || 'red';
  track = track || 'white';
  d = d > 360 ? 360 : d;

  if (d <= 180) {
    elem.style.background = `linear-gradient(90deg, ${track} 50%, transparent 50%), linear-gradient(${90 + d}deg, ${fill} 50%, ${track} 50%)`;
  } else {
    elem.style.background = `linear-gradient(-90deg, ${fill} 50%, transparent 50%), linear-gradient(${d - 90}deg, ${track} 50%, ${fill} 50%)`;
  }
}

const clearGradient = (elem) => (elem.style.background = null);

export {initTimer, createGradient, clearGradient};
